import styled from '@xstyled/styled-components';
import { system, SystemProps } from '@xstyled/system';
import { Icon as OfficeIcon, IIconProps } from '@fluentui/react';
import { FC } from 'react';

export const Icon: FC<SystemProps & IIconProps> = styled(OfficeIcon)`
  ${system}
`;
